import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import ProductCard from 'sections/product/partials/ProductCard';
import store from 'store';
export default class ColorSelector extends Component {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            card: ['.product-card', ProductCard]
        };
    }
    onMouseEnter(event) {
        const target = event.currentTarget;
        for (let i = 0; i < this.el.children.length; i++)
            this.el.children[i].classList.remove('hovered');
        target.classList.add('hovered');
    }
    onMouseLeave(event) {
        for (let i = 0; i < this.el.children.length; i++)
            this.el.children[i].classList.remove('hovered');
    }
    onClick(event) {
        const target = event.currentTarget;
        window.dispatchEvent(new CustomEvent('returns:update-color', {
            detail: {
                id: this.el.dataset.id,
                colorId: target.dataset.colorId,
                code: target.dataset.code,
                pattern: target.dataset.pattern,
                articleId: target.dataset.articleId
            }
        }));
        store.panel.set(null);
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        for (let i = 0; i < this.el.children.length; i++) {
            this.el.children[i][method]('mouseenter', (e) => this.onMouseEnter(e));
            this.el.children[i][method]('mouseleave', (e) => this.onMouseLeave(e));
            if (this.el.children[i].tagName === 'DIV')
                this.el.children[i][method]('click', (e) => this.onClick(e));
        }
    }
}
